<template>
  <b-card-group class="phairify-card__deck mt-4 phairify-insights">
    <b-card class="phairify-card__group-box mx-0">
      <template v-slot:header>
        <div class="header group-box__header phairify-body-copy font-weight-bold phairify-primary-teal">{{ title }}</div>
      </template>
      <div v-html="sanitizedContent" />
    </b-card>
  </b-card-group>
</template>

<script>
import sanitizeHtml from 'sanitize-html';
export default {
  name: 'InsightsDynamicSection',
  props: {
    title: String,
    content: String,
  },
  computed: {
    sanitizedContent: function () {
      return this.content ? sanitizeHtml(this.content) : '';
    }
  }
};
</script>

<style scoped></style>
